export default __webpack_public_path__ + "static/media/login_cover.22cdec4c.jpg";